<template>
    <SinMenuConAlertas :nombreAlerta="'ALERTA DE ACTIVIDADES - ' + title" :show="true" :showSemaforo="true" :url="'/sedes/' + municipio_id" :estaPagina="title">
        <template #contenido>  
            <div v-if="loader">
                <Loading />           
            </div>
            <div class="contenedor-simple" v-else>
                <h4 style="position: absolute; top: 1rem; left: 50%; transform: translateX(-50%); margin: 0; padding: 0; font-size: 2rem; font-weight: 700; color: #2d3748; z-index: 1; text-align: center; letter-spacing: -0.025em; text-shadow: 0 2px 8px rgba(45, 55, 72, 0.15); font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif; pointer-events: none;">{{ title }}</h4>
                <div class="row g-3 justify-content-center px-2" style="margin-top: 4rem; position: relative; z-index: 2;">
                    <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2" v-for="item, index in bloques" :key="index">
                        <div class="tarjeta-bloque" :class="getAlertClass(item.id)">
                            <router-link :to="'/unidades/' + item.id " class="tarjeta-link">
                                <div class="tarjeta-contenido">
                                    <div class="marcador-container">
                                        <div class="marcador-punto" :class="getAlertPointClass(item.id)">
                                            <b-icon icon="building" class="marcador-icon"></b-icon>
                                        </div>
                                        <div class="marcador-base"></div>
                                    </div>
                                    
                                    <div class="tarjeta-info">
                                        <h6 class="tarjeta-titulo">{{ item.bloque_edificio }}</h6>
                                        <div class="tarjeta-estado" v-if="getAlertLevel(item.id) > 0">
                                            <span class="estado-badge" :class="getAlertBadgeClass(item.id)">
                                                {{ getAlertLevel(item.id) }} {{ getAlertLevel(item.id) === 1 ? 'Alerta' : 'Alertas' }}
                                            </span>
                                        </div>
                                        <div class="tarjeta-estado" v-else>
                                            <span class="estado-badge estado-normal">
                                                <b-icon icon="check-circle" class="me-1"></b-icon>
                                                Normal
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </SinMenuConAlertas>   
</template>
<script>
    import ContentComponent from '@/components/Content/Index.vue';
    import SinMenuConAlertas from '@/layouts/SinMenuConAlertas.vue';
    import axios from 'axios';
    import Loading from '@/components/Loader/Loading.vue';
    export default {
        components:{
            ContentComponent, SinMenuConAlertas, Loading
        },
        props: ['municipio_id'],
        data() {
            return {
                aumento: 10,
                bloques: [],
                intervalId: null,
                loader: true,
                title: ''
            }
        },
        mounted() {
            
            this.getAlertas();
            this.getNumeroAlertas();
            this.getBloques();
            this.intervalId = setInterval(this.getAlertas, 60000);
        },
        beforeDestroy() {
            clearInterval(this.intervalId);
        },
        methods: {
            buscarSede(id){
                if(this.$store.state.numero_alertas.length > 0){
                    const personaBuscada = this.$store.state.numero_alertas.find(sede => sede.id === id);
                    return (personaBuscada) ? personaBuscada.total_alertas : 0;
                }
                return 0;
            },
            getAlertLevel(id) {
                return this.buscarSede(id) || 0;
            },
            getAlertClass(id) {
                const level = this.getAlertLevel(id);
                if (level >= 3) return 'alerta-critica';
                if (level === 2) return 'alerta-media';
                if (level === 1) return 'alerta-baja';
                return 'alerta-normal';
            },
            getAlertPointClass(id) {
                const level = this.getAlertLevel(id);
                if (level >= 3) return 'punto-critico';
                if (level === 2) return 'punto-medio';
                if (level === 1) return 'punto-bajo';
                return 'punto-normal';
            },
            getAlertBadgeClass(id) {
                const level = this.getAlertLevel(id);
                if (level >= 3) return 'badge-critico';
                if (level === 2) return 'badge-medio';
                if (level === 1) return 'badge-bajo';
                return 'badge-normal';
            },
            getAlertas(){
                const data = {
                    municipio: null, sede: this.$route.params.id, bloque: null, cbi: null
                }
                this.$store.dispatch('getAlertasActividad', data);
            },
            async getNumeroAlertas(){
                const data = {
                    dpto: null, mcpio: null, sede: this.$route.params.id, cbi: null
                }
                await this.$store.dispatch('countAlertasActividad', data);
                
            },
            getBloques(){
                axios.get(`/api/bloques/${this.$route.params.id}`, {
                    headers: {  
                        'Authorization': `Bearer ${this.$store.state.user.token}`
                    }
                }).then(response => {
                    this.bloques = response.data.bloques || [];
                    this.title = this.bloques[0]?.sede?.nombre || 'Sin título';
                    document.title = this.title;
                    this.loader = false;
                }).catch(error => {
                    this.loader = false;
                    console.error(error);
                }); 
            }
        },
    }
</script>
<style scoped>
/* Estilos existentes SVG */
@font-face { font-family:"Arial";font-variant:normal;font-style:normal;font-weight:normal;src:url("#FontID0") format(svg)}

.cove13 {fill:#848688}
.cove7 {fill:#333333}
.cove10 {fill:#920509}
.cove3 {fill:#999999}
.cove11 {fill:#A51D23}
.cove5 {fill:#B1B1AF}
.cove1 {fill:#B7CBD6}
.cove6 {fill:#D1CFC3}
.cove8 {fill:#DA1A21}
.cove12 {fill:#DD2B32}
.cove4 {fill:#E6E6E6}
.cove2 {fill:#E6E6E6}
.cove0 {fill:#F9F9F9}
.cove9 {fill:white}
.fnt0 {font-weight:normal;font-size:635px;font-family:'Arial'}

/* Estilos simplificados */
.contenedor-simple {
    background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
    min-height: 100vh;
    padding: 0.5rem;
    position: relative;
}

.titulo-simple {
    text-align: center;
    font-size: 1.8rem;
    font-weight: 700;
    color: #2d3748;
    margin: 0;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.tarjeta-bloque {
    background: #ffffff;
    border-radius: 16px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    border: 2px solid transparent;
    height: 180px;
    position: relative;
    overflow: hidden;
}

.tarjeta-bloque:hover {
    transform: translateY(-8px);
    box-shadow: 0 16px 48px rgba(0, 0, 0, 0.15);
}

.tarjeta-link {
    text-decoration: none;
    color: inherit;
    display: block;
    height: 100%;
}

.tarjeta-contenido {
    padding: 1.5rem;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    text-align: center;
}

.marcador-container {
    position: relative;
    margin-bottom: 1rem;
}

.marcador-punto {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    margin: 0 auto;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
    transition: all 0.3s ease;
}

.marcador-icon {
    font-size: 20px;
    color: white;
}

.marcador-base {
    width: 16px;
    height: 8px;
    background: rgba(0, 0, 0, 0.2);
    border-radius: 50%;
    margin: 4px auto 0;
    transform: perspective(10px) rotateX(45deg);
}

.tarjeta-info {
    width: 100%;
}

.tarjeta-titulo {
    font-size: 0.95rem;
    font-weight: 600;
    color: #2d3748;
    margin-bottom: 0.5rem;
    line-height: 1.3;
}

.tarjeta-estado {
    margin-top: 0.5rem;
}

.estado-badge {
    padding: 0.25rem 0.75rem;
    border-radius: 20px;
    font-size: 0.75rem;
    font-weight: 600;
    display: inline-flex;
    align-items: center;
    gap: 0.25rem;
}

/* Estilos para diferentes niveles de alerta */
.alerta-normal {
    border-color: #48bb78;
    background: linear-gradient(135deg, #f0fff4 0%, #f0fff4 100%);
}

.alerta-normal:hover {
    border-color: #38a169;
}

.alerta-baja {
    border-color: #ecc94b;
    background: linear-gradient(135deg, #fffff0 0%, #fffbeb 100%);
}

.alerta-baja:hover {
    border-color: #d69e2e;
}

.alerta-media {
    border-color: #ed8936;
    background: linear-gradient(135deg, #fffaf0 0%, #fef5e7 100%);
}

.alerta-media:hover {
    border-color: #dd6b20;
}

.alerta-critica {
    border-color: #f56565;
    background: linear-gradient(135deg, #fff5f5 0%, #fed7d7 100%);
}

.alerta-critica:hover {
    border-color: #e53e3e;
}

/* Puntos del marcador según el nivel */
.punto-normal {
    background: linear-gradient(135deg, #48bb78, #38a169);
}

.punto-bajo {
    background: linear-gradient(135deg, #ecc94b, #d69e2e);
}

.punto-medio {
    background: linear-gradient(135deg, #ed8936, #dd6b20);
}

.punto-critico {
    background: linear-gradient(135deg, #f56565, #e53e3e);
}

/* Badges de estado */
.estado-normal {
    background: #48bb78;
    color: white;
}

.badge-bajo {
    background: #ecc94b;
    color: #744210;
}

.badge-medio {
    background: #ed8936;
    color: white;
}

.badge-critico {
    background: #f56565;
    color: white;
}

/* Responsive simplificado */
@media (max-width: 768px) {
    .contenedor-simple {
        padding: 0.25rem;
    }
    
    .titulo-simple {
        font-size: 1.4rem;
    }
    
    .tarjeta-bloque {
        height: 160px;
    }
    
    .tarjeta-contenido {
        padding: 1rem;
    }
    
    .marcador-punto {
        width: 40px;
        height: 40px;
    }
    
    .marcador-icon {
        font-size: 16px;
    }
    
    .tarjeta-titulo {
        font-size: 0.85rem;
    }
}


</style>
